import React from 'react';
import ProjectCard from './ProjectCard/ProjectCard';
import {Grid} from '@material-ui/core';
import data from '../../data/javascriptData.json';

import weatherapp from '../../Assets/Animations/JS-HTML5-CSS3/weatherapp.gif';
import movieSeatBooking from '../../Assets/Animations/JS-HTML5-CSS3/movieSeatBooking.gif';
import ToDoListApp from '../../Assets/Animations/JS-HTML5-CSS3/ToDoListApp.gif';
import CheckoutPage from '../../Assets/Animations/JS-HTML5-CSS3/CheckoutPage.gif';
import MemoryCardGamePokemon from '../../Assets/Animations/JS-HTML5-CSS3/MemoryCardGamePokemon.gif';
import IOSCalculater from '../../Assets/Animations/JS-HTML5-CSS3/IOSCalculater.gif';

import useStyles from './styles';

const background = [weatherapp, movieSeatBooking, ToDoListApp, CheckoutPage, MemoryCardGamePokemon, IOSCalculater];

const ProjectJs = () => {
    const classes = useStyles();
    

    return (
        <div className={classes.root} id="projects">
            <Grid container direction="row"  justifyContent="space-evenly" align="center">
                {  
                    data.projects.map((data,i) => {
                        return (
                            <Grid key={data.sr} item xs={12} sm={6} lg={4}>
                                <ProjectCard 
                                title={data.title}
                                coverImage={background[i]}
                                date={data.date} 
                                summary={data.summary}
                                description={data.description}
                                features={data.features}
                                tags={data.tags}
                                github={data.github}
                                />
                            </Grid>
                        );
                    })
                }
            </Grid>  
        </div>
    );
};

export default ProjectJs;
